const userManagement = {
  route: undefined,
  label: 'User Management',
  resource: 'User Management',
  icon: undefined,
  items: [
    {
      route: '/users',
      label: 'Users',
      resource: 'User',
      icon: undefined,
      items: undefined,
    },
    {
      route: '/roles',
      label: 'Roles',
      resource: 'Role',
      icon: undefined,
      items: undefined,
    },
    {
      route: '/permission-sets',
      label: 'Permission Sets',
      resource: 'Permission',
      icon: undefined,
      items: undefined,
    }    
  ],
};

export const customer = {
  route: '/customers',
  label: 'Customers',
  resource: 'Customer',
  icon: undefined,
  items: undefined,
};

export const quote = {
  route: '/quotes',
  label: 'Quotes',
  resource: 'Quote',
  icon: undefined,
  items: undefined,
};


export const audit = {
  route: undefined,
  label: 'Audit',
  resource: 'Audit',
  icon: undefined,
  items: [
    {
      route: '/logs',
      label: 'Logs',
      resource: 'Log',
      icon: undefined,
      items: undefined,
    },
    {
      route: '/activities',
      label: 'Activities',
      resource: 'Activity',
      icon: undefined,
      items: undefined,
    },
    {
      route: '/consents',
      label: 'Consents',
      resource: 'Consent',
      icon: undefined,
      items: undefined,
    },
  ],
};

export const customerDuplicates = {
  route: '/customers/duplicates',
  label: 'Customer Duplicates',
  resource: 'CustomerDuplicate',
  icon: undefined,
  items: undefined,
};

export const recover = {
  route: undefined,
  label: 'Recover',
  resource: 'Recover',
  icon: undefined,
  items: [
    {
      route: '/recover/customers',
      label: 'Customers',
      resource: 'RecoverCustomer',
      icon: undefined,
      items: undefined,
    },
    {
      route: '/recover/quotes',
      label: 'Quotes',
      resource: 'RecoverQuote',
      icon: undefined,
      items: undefined,
    },
  ],
};

export const originalAdminItems = [
  {
    route: '/dashboard',
    label: 'Dashboard',
    resource: 'Dashboard',
    icon: 'assets/img/icon.png',
    items: undefined,
  },
  customer,
  quote,
  {
    route: undefined,
    label: 'Admin',
    resource: 'Admin',
    icon: undefined,
    items: [
      userManagement,
      audit,
      customerDuplicates,
      recover,
    ],
  },
];


